// DeleteInvoiceModal.jsx
import React from "react";
import "./Invoices.css";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Link } from "react-router-dom";

const DeleteInvoiceModal = ({ isOpen, toggle, onConfirm }) => (
  <Modal
    isOpen={isOpen}
    toggle={toggle}
    className="modal-delete modal-lg modal-dialog-centered"
  >
    <ModalHeader toggle={toggle}></ModalHeader>
    <ModalBody>Tem certeza em deletar essa venda?</ModalBody>
    <ModalFooter className="justify-content-center pt-4">
      <Link className="action-button" onClick={onConfirm}>
        Yes
      </Link>
      <Link className="action-button no" onClick={toggle}>
        No
      </Link>
    </ModalFooter>
  </Modal>
);

export default DeleteInvoiceModal;
